/**
 * @deprecated LEGACY — Team Insights onboarding API.
 * This onboarding flow is no longer active. Do not use in new code.
 * Kept for backward compatibility with existing users who completed this flow.
 */
import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

const onboardingStatusEndpoint = `${apiUrl}getInternalOnboardingTeamInsights/`;
const onboardingCompleteEndpoint = `${apiUrl}setInternalOnboardingTeamInsights/`;

export interface TeamInsightsOnboardingStatusRequest {
  OrgUUID: string;
}

export interface TeamInsightsOnboardingStatusResponse {
  value: number;
  Error: string | null;
}

export interface TeamInsightsOnboardingCompleteRequest {
  OrgUUID: string;
  done: 1;
}

export interface TeamInsightsOnboardingCompleteResponse {
  success: boolean;
  Error: string | null;
}

export function getTeamInsightsOnboardingStatus(
  payload: TeamInsightsOnboardingStatusRequest
) {
  return postWithAuth(onboardingStatusEndpoint, payload);
}

export function setTeamInsightsOnboardingComplete(
  payload: TeamInsightsOnboardingCompleteRequest
) {
  return postWithAuth(onboardingCompleteEndpoint, payload);
}
